import React from 'react'
import { TwoCol } from '../ProductLayout/TwoCol'
import { ISection, ISectionWrapper } from '../ProductLayout/types'
import { Section } from '../ProductLayout/Section'
import { Marquee } from '../ProductLayout/Marquee'
import { prepareData } from 'utils/googleData'

export const SectionWrapper = ({ children, direction, className = '' }: ISectionWrapper) => {
    return (
        <section dir={direction} className={`my-1 list-none py-4 md:py-12 ${className}`}>
            <div className={`mx-auto max-w-7xl`}>{children}</div>
        </section>
    )
}

export const Sections = (props: { sections: ISection[][] }) => {
    const { enable, sections, direction, gatsbyImage, gatsbyImage2, form } = prepareData({ props })
    if (enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    let transformedSections = []
    transformedSections = sections?.map((section, sectionIndex) => {
        const twoColSection = []
        if (section.right) {
            twoColSection.push(section.right)
        }
        if (section.left) {
            twoColSection.push(section.left)
        }
        return twoColSection
    })
    return (
        <>
            {transformedSections?.map((section, sectionIndex) => {
                return (
                    <SectionWrapper
                        direction={direction}
                        className="!my-0 py-12 md:my-auto md:py-14"
                        key={sectionIndex}
                    >
                        {section?.length > 1 ? (
                            <TwoCol>
                                {section?.map((sectionItem, index) => {
                                    let transformedSectionsItem = sectionItem
                                    if (
                                        Array.isArray(transformedSectionsItem) &&
                                        transformedSectionsItem?.length == 1
                                    ) {
                                        transformedSectionsItem = transformedSectionsItem[0]
                                    }

                                    return (
                                        <Section
                                            align={transformedSectionsItem?.align}
                                            direction={direction}
                                            key={index}
                                            {...transformedSectionsItem}
                                            callout={transformedSectionsItem?.callout}
                                            form={form}
                                            className={sectionIndex % 2 && index % 2 ? 'md:-order-1' : ''}
                                        />
                                    )
                                })}
                            </TwoCol>
                        ) : section?.[0]?.[0]?.marquee ? (
                            <Marquee enable={section?.[0]?.[0]?.enable} slides={section?.[0]?.[0]?.marquee} />
                        ) : (
                            <Section {...section?.[0]?.[0]} />
                        )}
                    </SectionWrapper>
                )
            })}
        </>
    )
}
export default Sections
